type VisibleCustomTransactionItemCountable = {
  type?: string | null;
  is_visible?: boolean | null;
};

export function countVisibleCustomTransactionItems(
  items: VisibleCustomTransactionItemCountable[] | undefined | null
): number {
  if (!items?.length) return 0;
  return items.filter(
    (item) => item.type === 'custom' && Boolean(item.is_visible)
  ).length;
}
